/* ZERNO-BUILD: v10-b9 */
/* ZERNO product page — gallery, size variants, add-on, prices.
   Self-contained. No theme dependencies beyond window.theme.routes. */
(function () {
  'use strict';

  function money(cents) {
    var t = window.theme;
    if (t && typeof t.formatMoney === 'function' && t.moneyFormat) {
      try {
        return t.formatMoney(
          cents,
          t.settings && t.settings.currency_code_enable ? t.moneyWithCurrencyFormat : t.moneyFormat
        );
      } catch (e) { /* fall through */ }
    }
    var n = (cents || 0) / 100;
    return '$' + (n % 1 === 0 ? String(n) : n.toFixed(2));
  }

  function init(root) {
    if (!root || root.__zpd) return;
    root.__zpd = true;

    var basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
    var addonPrice = 0;
    var addonId = '';
        var addonName = '';

    var priceEl = root.querySelector('[data-zpd-price]');
    var quarters = root.querySelectorAll('[data-zpd-quarter]');
    var setp = root.querySelector('[data-zpd-setp]');
    var setv = root.querySelector('[data-zpd-setv]');
    var idInput = root.querySelector('[data-zpd-id]');
    var atc = root.querySelector('[data-zpd-atc]');

    function paint() {
      var total = basePrice + addonPrice;
      if (priceEl) priceEl.textContent = money(basePrice);
      for (var i = 0; i < quarters.length; i++) quarters[i].textContent = money(Math.round(total / 4));
      if (setp) {
        if (addonPrice > 0) {
          setp.removeAttribute('hidden');
          if (setv) setv.textContent = money(total);
        } else {
          setp.setAttribute('hidden', '');
        }
      }
    }

    /* ---------- gallery: dots follow the swipe ---------- */
    var gal = root.querySelector('[data-zpd-gal]');
    var dotsWrap = root.querySelector('[data-zpd-dots]');
    if (gal && dotsWrap) {
      var dots = dotsWrap.querySelectorAll('i');
      var lastDot = -1, ticking = false;
      var thumbs = root.querySelectorAll('[data-zpd-thumb]');
      var thumbWrap = root.querySelector('[data-zpd-thumbs]');

      function markActive(i) {
        if (i === lastDot) return;
        lastDot = i;
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === i);
        for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-on', t === i);
        var el = thumbs[i];
        if (!el || !thumbWrap) return;
        var railW = thumbWrap.clientWidth;
        var max = thumbWrap.scrollWidth - railW;
        if (max <= 0) return;
        var target = el.offsetLeft - railW / 2 + el.offsetWidth / 2;
        thumbWrap.scrollTo({left: Math.max(0, Math.min(target, max)), behavior: 'smooth'});
      }

      gal.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = gal.clientWidth;
          if (w) markActive(Math.round(gal.scrollLeft / w));
        });
      }, {passive: true});

      for (var tk = 0; tk < thumbs.length; tk++) {
        (function (idx) {
          thumbs[idx].addEventListener('click', function () {
            gal.scrollTo({left: gal.clientWidth * idx, behavior: 'smooth'});
          });
        })(tk);
      }
    }

    /* ---------- size: real variants ---------- */
    var sizes = root.querySelectorAll('[data-zpd-size]');
    var sizeVal = root.querySelector('[data-zpd-sizeval]');
    for (var si = 0; si < sizes.length; si++) {
      sizes[si].addEventListener('click', function () {
        if (this.disabled) return;
        for (var j = 0; j < sizes.length; j++) sizes[j].classList.remove('is-on');
        this.classList.add('is-on');

        var vid = this.getAttribute('data-zpd-size');
        var vp = parseInt(this.getAttribute('data-zpd-size-price'), 10);
        if (idInput && vid) idInput.value = vid;
        if (!isNaN(vp)) basePrice = vp;
        if (sizeVal) sizeVal.textContent = this.getAttribute('data-zpd-size-label') || '';

        if (vid && window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', vid);
          history.replaceState({}, '', u.toString());
        }
        paint();
      });
    }

    /* ---------- add-on ---------- */
    var addon = root.querySelector('[data-zpd-addon]');
    if (addon) {
      var cards = addon.querySelectorAll('[data-zpd-addon-card]');
      addon.addEventListener('click', function (e) {
        var card = e.target.closest('[data-zpd-addon-card]');
        if (!card || !addon.contains(card)) return;
        for (var c = 0; c < cards.length; c++) cards[c].classList.remove('is-on');
        card.classList.add('is-on');
        addonId = card.getAttribute('data-addon-id') || '';
        addonPrice = parseInt(card.getAttribute('data-addon-price'), 10) || 0;
                addonName = card.getAttribute('data-addon-title') || '';
        paint();
      });
    }

    /* ---------- submit: chain, then bracelet, then open the drawer ---------- */
    var form = root.querySelector('[data-zpd-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc && atc.disabled) return;

        var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
        var items = [{id: idInput.value, quantity: 1}];
        if (addonId) items.push({id: addonId, quantity: 1});

        if (atc) { atc.disabled = true; atc.classList.add('is-loading'); }

        fetch(url + '.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: items})
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
            document.dispatchEvent(new CustomEvent('theme:cart:open', {bubbles: true}));
          })
          .catch(function () { window.location = '/cart'; })
          .then(function () {
            if (atc) { atc.disabled = false; atc.classList.remove('is-loading'); }
          });
      });
    }

    /* ---------- sticky bar ----------
       Fixed to the viewport, so it survives past this section and stays for
       the rest of the page. Revealed once the real Add to cart scrolls above
       the fold, hidden again when you scroll back up to it. */
    var stPrice = root.querySelector('[data-zpd-stprice]');
    var stBtn = root.querySelector('[data-zpd-stbtn]');
    var sticky = root.querySelector('[data-zpd-sticky]');
    if (stBtn && form) {
      stBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}));
      });
    }
    if (sticky && atc) {
      var stTicking = false;
      var syncSticky = function () {
        /* show once the real button has scrolled above the fold, and keep it
           for the rest of the page — it is fixed, not sticky, so nothing
           clips it when this section ends */
        var past = atc.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-on', past);
      };
      var onScroll = function () {
        if (stTicking) return;
        stTicking = true;
        requestAnimationFrame(function () { stTicking = false; syncSticky(); });
      };
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll, {passive: true});
      syncSticky();
    }

    /* ---------- rail arrows (desktop) ---------- */
    root.querySelectorAll('[data-zpd-rw]').forEach(function (rw) {
      var rail = rw.querySelector('[data-zpd-rail]');
      var arws = rw.querySelectorAll('[data-zpd-arw]');
      if (!rail || !arws.length) return;

      function step() {
        var card = rail.firstElementChild;
        return card ? card.getBoundingClientRect().width + 10 : 160;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        arws.forEach(function (a) {
          var dir = parseInt(a.getAttribute('data-zpd-arw'), 10);
          var atEnd = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
          if (max <= 2 || atEnd) a.setAttribute('disabled', '');
          else a.removeAttribute('disabled');
        });
      }
      arws.forEach(function (a) {
        a.addEventListener('click', function () {
          rail.scrollBy({left: parseInt(a.getAttribute('data-zpd-arw'), 10) * step(), behavior: 'smooth'});
        });
      });
      rail.addEventListener('scroll', sync, {passive: true});
      window.addEventListener('resize', sync, {passive: true});
      sync();
      setTimeout(sync, 200);
    });

    /* ---------- quick add from the stack rail ---------- */
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-zpd-quick]');
      if (!q || !root.contains(q)) return;
      e.preventDefault();
      var vid = q.getAttribute('data-zpd-quick');
      if (!vid) return;
      var label = q.textContent;
      q.textContent = 'Adding...';
      q.disabled = true;
      var url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      fetch(url + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: vid, quantity: 1}]})
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          document.dispatchEvent(new CustomEvent('theme:cart:open', {bubbles: true}));
        })
        .catch(function () {})
        .then(function () { q.textContent = label; q.disabled = false; });
    });

        var stAdd = root.querySelector('[data-zpd-stadd]');
    var stBadge = root.querySelector('[data-zpd-stbadge]');
    var origPaint = paint;
    paint = function () {
      origPaint();
      if (stPrice) stPrice.textContent = money(basePrice + addonPrice);
      var extras = addonId ? 1 : 0;
      if (stBadge) {
        if (extras > 0) { stBadge.textContent = String(1 + extras); stBadge.removeAttribute('hidden'); }
        else { stBadge.setAttribute('hidden', ''); }
      }
      if (stAdd) {
        if (extras > 0) { stAdd.textContent = '+' + extras + (extras === 1 ? ' item' : ' items'); stAdd.removeAttribute('hidden'); }
        else { stAdd.setAttribute('hidden', ''); }
      }
    };

    paint();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-zerno-product]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
